import { createSlice } from '@reduxjs/toolkit';
import { fetchVideoDetails, trimVideo } from '../../Service/VideoEdit/VideoEdit_API';

const adminVideoEditSlice = createSlice({
  name: 'videoEdit',
  initialState: {
    videoDetails: null,
    loading: false,
    triming: false,
    error: null
  },
  reducers: {
    clearVideoEditState: (state) => {
      state.videoDetails = null;
      state.loading = false;
      state.triming = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // fetchVideoDetails
      .addCase(fetchVideoDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVideoDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.videoDetails = action.payload;
      })
      .addCase(fetchVideoDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch video details';
      })
      // trimVideo
      .addCase(trimVideo.pending, (state) => {
        state.triming = true;
      })
      .addCase(trimVideo.fulfilled, (state) => {
        state.triming = false;
      })
      .addCase(trimVideo.rejected, (state, action) => {
        state.triming = false;
        state.error = action.payload || 'Failed to trim video';
      });
  }
});

export const { clearVideoEditState } = adminVideoEditSlice.actions;
export const selectVideoEdit = (state) => state.videoEdit;
export default adminVideoEditSlice.reducer;
